const NavigationPath = (() => {
  const container = document.getElementById("navigation-path");
  const items = Array.from(
    container.querySelectorAll(
      ".navigation-path__link, .navigation-path__separator"
    )
  );
  const ellipsis = container.querySelector(".navigation-path__ellipsis");

  const resizeNavigationPath = () => {
    const totalWidth = container.clientWidth;
    let usedWidth = ellipsis.offsetWidth;

    ellipsis.classList.add("hidden");
    items.forEach((item) => (item.hidden = false));

    for (let i = items.length - 1; i >= 0; i--) {
      usedWidth += items[i].offsetWidth;

      if (usedWidth > totalWidth) {
        items[i].hidden = true;
        ellipsis.classList.remove("hidden");
      }
    }
  };

  const init = () => {
    window.addEventListener("load", resizeNavigationPath);
    window.addEventListener("resize", resizeNavigationPath);
  };

  return {
    init,
  };
})();

NavigationPath.init();
